import React from 'react';
import Loader from 'react-loader-spinner'
import {Header} from "../../layout/Header/Header";
import {Balances} from "./Balances/Balances";
import {LeaderBoard} from "./LeaderBoard/LeaderBoard";
import {Transactions} from "./Transactions/Transactions";
import {useWeb3App} from "../../core/appContext";
import WalletConnectProvider from "@walletconnect/web3-provider";
import Web3Modal from 'web3modal'
import {walletConnectOpts, networksConfig, defaultNetwork} from "../../config";
import {Footer} from "../../layout/Footer/Footer";
import styles from './Dashboard.module.sass'
import {Chart} from "./Chart/Chart";
import {Forms} from "./Forms";

let web3Modal
let provider

export function Dashboard() {
    const ghApp = useWeb3App()
    async function login() {
        web3Modal = new Web3Modal({
            network: 'kovan',
            cacheProvider: true,
            providerOptions: {
                walletconnect: {
                    package: WalletConnectProvider,
                    options: walletConnectOpts
                },
            }
        })
        try {
            provider = await web3Modal.connect()

            if (provider.chainId !== networksConfig[defaultNetwork]?.chainId) {
                try {
                    await provider.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{ chainId: networksConfig[defaultNetwork].chainId }],
                    });
                } catch (error) {
                    // This error code indicates that the chain has not been added to MetaMask.
                    if (error.code === 4902) {
                        try {
                            const info = await provider.request(networksConfig[defaultNetwork]?.metamaskSettings)
                            console.log('network switched', info)
                        } catch (error) {
                            console.warn('Switch network error', error)
                        }
                    }
                    // handle other "switch" errors
                }
            }
        } catch(e) {
            console.log("Could not get a wallet connection", e);
            return;
        }
        ghApp.init(provider)
    }
    const [balances, setBalanaces] = React.useState()
    const [leaderBoard, setLeaderBoard] = React.useState()
    const [transactions, setTransactions] = React.useState()
    const [walletIsLoading, setWalletIsLoading] = React.useState(true)
    React.useEffect(() => {
        const loadData = async (account) => {
            account = account ? account : ghApp.account

            async function getData() {
                setBalanaces(await ghApp.getBalances(account))
                setLeaderBoard(await ghApp.getLeaderboard(account))
                // console.log('%cindex.js line:71 await ghApp.getLatestTransactions()', 'color: #007acc;', await ghApp.getLatestTransactions());
                setTransactions(await ghApp.getLatestTransactions())
            }

            getData()
        }
        const loadedWallet = () => setWalletIsLoading(false)

        ghApp.on('account', loadData)
        ghApp.on('tx:success', loadData)
        ghApp.on('wallet', loadedWallet)

        return () => {
            web3Modal && web3Modal.clearCachedProvider()
            ghApp.remove('account', loadData)
            ghApp.on('tx:success', loadData)
            ghApp.on('wallet', loadedWallet)
        }
    }, [])
    const dataIsLoading = React.useMemo(() => {
        if (!ghApp.netId || !ghApp.account) return false
        if (!balances || !leaderBoard || !transactions) return true
        return false
    }, [ghApp, walletIsLoading, balances, leaderBoard, transactions])

    return (
        <div className={styles.wrap}>
            <div className={styles.main}>
               <div className={styles.body}>
                   <Header/>
                   {/* {(walletIsLoading || dataIsLoading) && (
                       <div className={styles.wrap_loader}>
                           <Loader
                               type="Rings"
                               color="#3CBE99"
                               height={300}
                               width={300}
                           />
                       </div>
                   )} */}
                   {(!ghApp.account || !ghApp.netId) && (
                       <div className={styles.enter}>
                           <div onClick={login} className={styles.enter_btn}>
                               Connect to Wallet
                           </div>
                       </div>
                   )}
                   {( !walletIsLoading && ghApp.account && ghApp.netId) && (
                       <div>
                           <Balances balances={balances} />
                           <div className={styles.chart_forms}>
                               <div className={styles.title}>Contract Balances</div>
                               <Chart />
                               <Forms balances={balances} />
                           </div>
                           <div className={styles.tables}>
                               <LeaderBoard leaderBoard={leaderBoard} balances={balances} />
                               <Transactions transactions={transactions} />
                           </div>
                       </div>
                   )}
               </div>
            </div>
            <Footer/>
        </div>
    )
}
